import ClientUserDetails from './components/client-user-details';
import { useSetPageTitle } from 'src/hooks/useSetPageTitle';
import { DashboardMenubar } from 'src/components/menubar/menubar';
import ClientListDetails from './components/client-list-details';

const ClientProfilePage = () => {
  useSetPageTitle('Account Settings');

  return (
    <div className='min-h-screen w-full bg-[#F6F6F6]'>
      {/* Older tabbed header layout: <ProfileNav /> */}
      <DashboardMenubar bgColorClass="!justify-end" />
      <div className="flex justify-center p-6 sm-max:px-0">
        <div className="w-full max-w-3xl gap-4 flex flex-col">
          <ClientUserDetails />
          <ClientListDetails />
        </div>
      </div>
    </div>
  );
};

export default ClientProfilePage;
